import styled from "styled-components"
import { motion } from "framer-motion"
import theme from "../../../theme"


export const HeroImageAnimation = {
  initial: {
    scale: 1.4
  },
  animate: {
    scale: 1
  },
  transition: {
    type: "spring",
    stiffness: 260,
    damping: 100
  }
}

export const HeaderIconAnimation = {
  initial: {
    opacity: .5,
    scale: 2
  },
  animate: {
    opacity: 1,
    scale: 1
  },
  transition: {
    type: "spring",
    stiffness: 300,
    damping: 40
  }
}


export const Header = styled.header`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  height: ${props => props.size}vh;
  width: 100%;
  justify-content: center;
  align-items: center;
  user-select: none;
  margin-top: 60px;
`

export const HeroImage = styled(motion.img)`
  position: absolute;
  min-height: 100%;
    
  @media (min-width: 1024px) {
    min-width: 100%;
  }
  
`

export const DecorateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  z-index: 2;
  
  & > a.decorate{
    display: flex;
    max-height: 500px;
    opacity: .9;
    cursor: inherit;
  }
`

export const DecoratorLabel = styled(motion.h1)`
  font-size: 2rem;
  color: ${theme.text.reverse};
  font-weight: 600;
  line-height: 1;
  letter-spacing: -.015em;
  margin: 0 0 8px 0;
  
  @media (min-width: 1024px) {
    font-size: 4rem;
  }
`
